<ion-header>
  <app-header pageName="{{'OTP_VERIFICATION'| translate}}">
  </app-header>
</ion-header>

<div class="ion-padding-vertical" >
  <ion-list>
    <ion-item class="ion-margin-end" class="otp-selection-wrapper">
      <ion-label slot="start">{{'UNLOCK_WITH_OTP'| translate}}</ion-label>
      <ion-select class="otp-selection" placeholder="{{'UNLOCK_WITH_OTP'| translate}}" [(ngModel)]="otpSendBy" [disabled]="activeOTP">
        <ion-select-option *ngFor="let option of otpOption" [value]="option">{{option}}</ion-select-option>
      </ion-select>
    </ion-item>
    <ion-item class="ion-margin-end" *ngIf="activeOTP">
      <ion-input [attr.aria-label]="'OTP_CODE' | translate" class="card-num-input" type="text" [(ngModel)]="otp" 
        placeholder="{{ 'ENTER_OTP_CODE' | translate}}">
      </ion-input>
    </ion-item>
  </ion-list>
  <ion-row class="ion-margin-top">
    <ion-col class="ion-padding-horizontal">
      <ion-button color="eprintprimary" expand="full" [disabled]="!otpSendBy || (activeOTP && !otp) " (click)="onSubmit()">
        {{ (activeOTP ? 'VERIFY' :'SEND') | translate }}
      </ion-button>
    </ion-col>
  </ion-row>
</div>